module.exports = __webpack_public_path__ + "/bundle/asset/collego-695c0d933d3ac6cbddf882c9693b1d92.png";